import { Inject, Injectable } from '@angular/core';
import { CORE_WINDOW_CONFIG, CoreWindowConfig } from './config';
import { WindowService } from './window.service';

@Injectable({ providedIn: 'root' })
export class IframeMessageBus {
  constructor(
    @Inject(CORE_WINDOW_CONFIG) private _config: CoreWindowConfig,
    private _window: WindowService,
  ) {}

  sendToParent(eventName: string, payload: object = {}) {
    if (this._config.isEmbedded) {
      this._window.parent.postMessage({
        id: ['iframe', eventName].join('.'),
        ...payload,
      });
    }
  }

  setParentTitle(title: string) {
    this.sendToParent('setTitle', { title });
  }

  triggerParentNavigation(route: string) {
    this.sendToParent('navigate', { route });
  }

  show() {
    this.sendToParent('show');
  }

  requestToken() {
    this.sendToParent('requestToken');
  }

  resize(height: number) {
    this.sendToParent('resize', { height });
  }

  onModalOpen(top: number) {
    this.sendToParent('onModalOpen', { top });
  }

  onModalClose() {
    this.sendToParent('onModalClose');
  }

  triggerCustomEvent(eventName: string, param?: unknown) {
    this.sendToParent(
      eventName,
      ...(param !== undefined ? [{ ...param }] : []),
    );
  }
}
